module.exports = __webpack_public_path__ + "static/app-store-qr-673568eb80cd75eff665aa2cc8096274.svg";